
import { getSurvey, sendSurvey } from "./api"
import { takeLatest, put, call, all } from 'redux-saga/effects';
import { actions } from './action';
import constants from './constants';

function* GetSurvey(action) {
  const { data, error } = yield call(() => getSurvey(action.surveyKey, action.stayGuid).then(response => response));
  if (data) {
    yield put(actions.getSurveySuccess(data));
  }
  else {
    yield put(actions.GetSurveyFailed(error));
  }
}

function* SendSurvey(action) {
  const { data, error } = yield call(() => sendSurvey(action.surveyResponse.data).then(response => response));
  if (data) {
    const surveyKey = action.surveyResponse.data.surveyKey;
    const stayGuid = action.surveyResponse.data.stayGuid;
    const newUrl = `${window.location.pathname}?key=${surveyKey}&guid=${stayGuid}&status=done`;

    // Redirect to the new URL
    window.location.href = newUrl;

    yield put(actions.sendSurveyResponseSuccess(true));
  }
  else {
    yield put(actions.sendSurveyResponseFailed(error));
  }
}


export default function* rootSaga() {
  yield all([
    takeLatest(constants.GET_SURVEY, GetSurvey),
    takeLatest(constants.SEND_SURVEY_RESULT, SendSurvey)
  ]);
}